import * as Yup from "yup";

export const documentValidation = () =>
  Yup.mixed()
    .nullable()
    .notRequired()
    .test(
      "fileType",
      "Only images (JPG, JPEG, PNG) and PDF files are allowed",
      (value) => {
        if (!value) return true; // Allow empty/null values since it's optional

        // Handle both file objects and existing file URLs/paths
        if (typeof value === "string") return true; // Existing document URL
        if (value?.file && typeof value.file === "object") {
          const acceptedTypes = [
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/pdf",
          ];
          return acceptedTypes.includes(value.file.type);
        }
        if (value?.type) {
          const acceptedTypes = [
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/pdf",
          ];
          return acceptedTypes.includes(value.type);
        }
        return true;
      }
    )
    .test("fileSize", "File size must be less than 5MB", (value) => {
      if (!value) return true; // Allow empty/null values since it's optional

      // Handle both file objects and existing file URLs/paths
      if (typeof value === "string") return true; // Existing document URL
      if (value?.file && typeof value.file === "object") {
        return value.file.size <= 5 * 1024 * 1024; // 5MB in bytes
      }
      if (value?.size) {
        return value.size <= 5 * 1024 * 1024; // 5MB in bytes
      }
      return true;
    });
